const type = 'SET_PAYMENT_SMS_SENDING';

const setPaymentSMSSending = (data) => ({
  data,
  type,
});

export default setPaymentSMSSending;
